@if (dataCatalogStatus && dataCatalogStatus.messages?.length || mediaItemsByStatus?.['NOT_FOUND']?.length || mediaItemsByStatus?.['INVALID']?.length) {
  <div class="upload-response alert alert-warning">
    <ul ngbNav #nav="ngbNav" class="nav-tabs">
      @if (dataCatalogStatus && dataCatalogStatus.messages?.length) {
        <li [ngbNavItem]="1">
          <a ngbNavLink>
            <strong>{{ translatedErrorsLength }}</strong>
            {{ "Template.UploadComponent.text_errors" | translate}}
          </a>
          <!-- <ng-template ngbNavContent [ngIf]="errors"> -->
          <ng-template ngbNavContent>
            <app-messages [messages]="errors" (translatedEvent)="setTranslatedErrors($event)" ></app-messages>
          </ng-template>
        </li>
      }
      @if (dataCatalogStatus?.messages?.length) {
        <li [ngbNavItem]="2">
          <a ngbNavLink>
            <strong>{{ translatedWarningsLength }}</strong>
            {{ "Template.UploadComponent.text_warnings" | translate}}
          </a>
          <!-- <ng-template ngbNavContent [ngIf]="warnings"> -->
          <ng-template ngbNavContent>
            <app-messages [messages]="warnings" (translatedEvent)="setTranslatedWarnings($event)" ></app-messages>
          </ng-template>
        </li>
      }
      @if (mediaItemsByStatus?.['NOT_FOUND']?.length) {
        <li [ngbNavItem]="3">
          <a ngbNavLink>
            <strong>{{ mediaItemsByStatus["NOT_FOUND"]?.length }}</strong>
            {{ "Template.UploadComponent.text_missingMedia" | translate}}
          </a>
          <ng-template ngbNavContent>
            <ul>
              @for (mediaItem of mediaItemsByStatus['NOT_FOUND']; track mediaItem) {
                <li>
                  @if (mediaItem.originalFilename) {
                    <span>{{ mediaItem.originalFilename }}</span>
                  }
                  @if (mediaItem.originalUrl) {
                    <span>{{ mediaItem.originalUrl }}</span>
                  }
                  @if (mediaItem.message?.ean && mediaItem.message?.supplierArticleNo) {
                    <span> ({{mediaItem.message?.ean}} / {{mediaItem.message?.supplierArticleNo}})</span>
                  }
                  @if (mediaItem.message?.messageCode) {
                    <span>: {{"MediaItemMessages." + mediaItem.message?.messageCode | translate}}</span>
                  }
                </li>
              }
            </ul>
          </ng-template>
        </li>
      }
      @if (mediaItemsByStatus?.['INVALID']?.length) {
        <li [ngbNavItem]="4">
          <a ngbNavLink>
            <strong>{{ mediaItemsByStatus["INVALID"]?.length }}</strong>
            {{ "Template.UploadComponent.text_invalidMedia" | translate}}
          </a>
          <ng-template ngbNavContent>
            <ul>
              @for (mediaItem of mediaItemsByStatus['INVALID']; track mediaItem) {
                <li>
                  @if (mediaItem.originalFilename) {
                    <span>{{ mediaItem.originalFilename }}</span>
                  }
                  @if (mediaItem.originalUrl) {
                    <span>{{ mediaItem.originalUrl }}</span>
                  }
                  @if (mediaItem.message?.ean && mediaItem.message?.supplierArticleNo) {
                    <span> ({{mediaItem.message?.ean}} / {{mediaItem.message?.supplierArticleNo}})</span>
                  }
                  @if (mediaItem.message?.messageCode) {
                    <span>: {{"MediaItemMessages." + mediaItem.message?.messageCode | translate}}</span>
                  }
                </li>
              }
            </ul>
          </ng-template>
        </li>
      }
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  </div>
}
